import { tv } from 'tailwind-variants'

export const skeletonVariants = tv({
  base: 'block bg-paper-elevation3',
  variants: {
    variant: {
      text: 'rounded-sm origin-[0_55%] scale-y-[0.6]',
      circular: 'rounded-full',
      rectangular: '',
      rounded: 'rounded-sm',
    },
    animation: {
      wave: [
        'relative overflow-hidden',
        'after:absolute after:inset-0 after:content-[""]',
        // Start the shimmer off-screen so the 0.5s animation-delay shows a clean
        // surface, not a static gradient band parked mid-element before the sweep.
        // Reduced motion drops the sweep entirely (a repeating full-width translation
        // is a canonical vestibular trigger); the static surface still reads as loading.
        'after:-translate-x-full after:bg-skeleton-wave after:animate-skeleton-wave motion-reduce:after:animate-none',
      ],
      pulse: 'animate-skeleton-pulse motion-reduce:animate-none',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'text',
    animation: 'wave',
  },
})
